/**
 * 0- default, popularity, 1 - date , 2 - price low to hight, 3 - price high to low
 */
export const homeAllEventsSortModes = [
  { title: "Sort by date", sort: 1 },
  { title: "Sort by Popularity", sort: 0 },
  { title: "Price low to high", sort: 2 },
  { title: "Price high to low", sort: 3 },
];
